import { useRef, useEffect } from 'react';

export const useMemoCompare = <O,>(
  next: O,
  compare: (p: O, n: O) => boolean,
): O => {
  // Ref for storing previous value
  const previousRef = useRef<O | null>(null);
  // TODO : check if we can refactor this code in order to respect this rule
  // eslint-disable-next-line react-hooks/refs
  const previous = previousRef.current;
  // Pass previous and next value to compare function
  // to determine whether to consider them equal.
  let isEqual = true;
  if (previous && next) {
    isEqual = compare(previous, next);
  }
  // If not equal update previousRef to next value.
  // We only update if not equal so that this hook continues to return
  // the same old value if compare keeps returning true.
  useEffect(() => {
    if (!isEqual) {
      previousRef.current = next;
    }
  });
  // Finally, if equal then return the previous value
  // TODO : check if we can refactor this code in order to respect this rule
  // eslint-disable-next-line react-hooks/refs
  if (!previous) {
    return next;
  }
  return isEqual ? previous : next;
};
